<template>
   <div :class="`gts-alert gts-alert_${status} ${rounded ? '' : 'no-round'}`">
      <slot />
   </div>
</template>

<script>
export default {
   name: "UIAlert",
   props: {
      status: { type: String },
      rounded: Boolean,
   },
};
</script>

<style lang="scss" scoped>
.gts-alert {
   display: flex;
   align-items: center;
   justify-content: flex-start;
   background-color: transparent;
   padding: 12px 16px;
   border: 1px solid;
   border-radius: 8px;
   margin-bottom: 1rem;

   p {
      padding: 0;
      margin: 0;
   }

   &_default {
      background-color: var(--gray-100);
      border-color: var(--gray-300);
      color: var(--gray-900);
   }

   &_default__light {
      background-color: var(--gray-0);
      /* box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1); */
      box-shadow: var(--gts-box-shadow);
      border: 1px solid var(--gray-200);
      border-radius: 12px;
      color: var(--gray-800);
   }

   &_info {
      background-color: var(--blue-100);
      border-color: var(--blue-400);
      color: var(--blue-800);
   }

   &_alert {
      background-color: var(--yellow-100);
      border-color: var(--yellow-400);
      color: var(--yellow-900);
   }

   &_warning {
      background-color: var(--orange-100);
      border-color: var(--orange-500);
      color: var(--orange-800);
   }

   &_danger {
      background-color: var(--red-600);
      border-color: var(--red-600);
      color: var(--gray-0);
   }

   // Info varyasyonları - açık arka planlı
   &_info_green,
   &_success {
      background-color: var(--green-100-alpha-50);
      border-color: var(--green-500);
      color: var(--green-900);
   }

   &_info_blue {
      background-color: var(--blue-100);
      border-color: var(--blue-500);
      color: var(--blue-900);
   }

   &_info_yellow {
      background-color: var(--yellow-100);
      border-color: var(--yellow-500);
      color: var(--yellow-900);
   }

   &_info_red,
   &_info_red1 {
      background-color: var(--red-500);
      border-color: var(--red-500);
      color: var(--txt-white);
   }

   &_info_orange,
   &_info_orange2 {
      background-color: var(--orange-100);
      border-color: var(--orange-400);
      color: var(--orange-900);
   }

   // Alternatif varyasyonlar
   &_subtle_gray {
      //background-color: var(--gray-50);
      background-color: var(--gray-0);
      border-color: var(--gray-400);
      color: var(--gray-700);
   }

   &_subtle_orange {
      background-color: var(--orange-0);
      border-color: var(--orange-300);
      color: var(--orange-700);
   }

   &_strong_red {
      background-color: var(--red-600);
      border-color: var(--red-700);
      color: var(--gray-0);
   }

   &_strong_orange {
      background-color: var(--orange-500);
      border-color: var(--orange-600);
      color: var(--gray-0);
   }
}

.dark-theme .gts-alert {
   &_default {
      background-color: var(--gray-300);
      border-color: var(--gray-500);
      color: var(--gray-1000);
   }

   &_default__light {
      background-color: var(--gray-200);
      border-color: var(--gray-400);
      color: var(--gray-900);
   }

   &_info {
      background-color: var(--blue-900);
      border-color: var(--blue-500);
      color: var(--blue-500);
   }

   &_alert {
      background-color: var(--yellow-900);
      border-color: var(--yellow-500);
      color: var(--yellow-500);
   }

   &_warning {
      background-color: var(--orange-900);
      border-color: var(--orange-500);
      color: var(--orange-500);
   }

   &_danger {
      background-color: var(--red-600);
      border-color: var(--red-500);
      color: var(--gray-1000);
   }

   &_info_green,
   &_success {
      background-color: var(--green-900);
      border-color: var(--green-500);
      color: var(--green-500);
   }

   &_info_blue {
      background-color: var(--blue-900);
      border-color: var(--blue-500);
      color: var(--blue-500);
   }

   &_info_yellow {
      background-color: var(--yellow-900);
      border-color: var(--yellow-500);
      color: var(--yellow-500);
   }

   &_info_red {
      background-color: var(--red-900);
      border-color: var(--red-500);
      color: var(--red-500);
   }

   &_info_orange {
      background-color: var(--orange-900);
      border-color: var(--orange-500);
      color: var(--orange-500);
   }

   &_subtle_gray {
      background-color: var(--gray-300);
      border-color: var(--gray-500);
      color: var(--gray-900);
   }

   &_subtle_orange {
      background-color: var(--orange-300);
      border-color: var(--orange-500);
      color: var(--orange-900);
   }

   &_strong_red {
      background-color: var(--red-600);
      border-color: var(--red-500);
      color: var(--gray-1000);
   }

   &_strong_orange {
      background-color: var(--orange-600);
      border-color: var(--orange-500);
      color: var(--gray-1000);
   }
}
</style>

<style lang="scss">
.gts-alert {
   ul {
      li {
         margin-left: 1rem !important;
      }
   }
}
</style>
